import React from "react";
import CourseRecap from "./Recap";
import { BASE_URL, CheckAuth, FormatDateIndo } from "../Util";
import { Col, Icon, Row } from "react-materialize";
import { Link } from "react-router-dom";
import QuizHeader from "../Quiz/Header";
import FontAwesome from "react-fontawesome";
import { trans } from "../Lang";
import Undp_img from "./../../assets/undp-horizontal.png";
import Smile_img from "./../../assets/smile.png";
import kemenkes_img from "./../../assets/kemenkes-horizontal.png";
import gavi_img from "./../../assets/gavi.png";
import globalfund_img from "./../../assets/global_fund.png";
import Sign_img from "./../../assets/sign-siprianus.jpg";
import bgCertificate from "./../../assets/bg-certificate.png";
import { ShareButtons } from "react-share";

class CourseCertificate extends CourseRecap {
  constructor(props) {
    super(props);
  }

  render() {
    let data = this.state.data;
    if (!data) {
      return super.render();
    }

    return (
      <div>
        <QuizHeader data={data} />
        <CertificateItem data={data} />
      </div>
    );
  }
}

class CertificateItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let data = this.props.data;
    let url = BASE_URL + `/certificate.php?uuid=${data.uuid}`;
    let shareUrl = url;
    let shareContent = `Saya sudah menyelesaikan ${trans.course} ${data.title} di SMILE e-Learning`;
    let userdata = CheckAuth();
    let isOwner = userdata != "";

    return (
      <div className="certificate-wrapper">
        <div
          className="certificate-section quattrocento-regular"
          style={{
            position: "relative",
            backgroundImage: `url(${bgCertificate})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                gap: "32px",
              }}
            >
              <img src={globalfund_img} height={48} />
              <img src={gavi_img} height={32} />
              <img src={kemenkes_img} height={40} />
              <img src={Undp_img} height={52} />
            </div> */}
          <div
            className="center content-ceritificate"
            style={{ padding: "96px 32px 64px 32px " }}
          >
            <div className="title">CERTIFICATE OF PARTICIPATION</div>
            <div className="subtitle">THIS CERTIFICATE IS PRESENTED TO:</div>
            <div className="name">
              {userdata ? userdata.nama : data.student_name}
            </div>
            <div className="border-name">&nbsp;</div>
            <div style={{ marginTop: "16px", color: "#a27f16" }}>
              For completing the training of
            </div>
            <div className="title-course">{data.title}</div>

            <div>
              <div
                style={{
                  width: "128px",
                  position: "absolute",
                  left: "64px",
                  bottom: "96px",
                }}
              >
                <img src={Smile_img} height={64} style={{ width: "100%" }} />
              </div>
              <div className="sign">
                <img src={Sign_img} height={64} />
              </div>
              <div className="sign-name">Siprianus Bate Soro</div>
              <div
                style={{
                  fontSize: "12px",
                }}
              >
                Assistant Resident Representative/Team Leader for Democratic
                Governance and Poverty Reduction, UNDP Indonesia
              </div>
            </div>

            {/* <div className="strong font-grey mb-m">{data.category.name}</div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default CourseCertificate;
export { CertificateItem };



// WEBPACK FOOTER //
// ./src/components/Course/Certificate.js